function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.723 9a1.723 1.723 0 1 1-3.446 0 1.723 1.723 0 0 1 3.446 0",
    fill: "#fff",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.029 5.952a1.6 1.6 0 0 0-.387-.594 1.6 1.6 0 0 0-.594-.387c-.182-.07-.456-.155-.96-.178-.545-.024-.708-.03-2.088-.03s-1.543.005-2.088.03c-.504.023-.778.108-.96.178a1.6 1.6 0 0 0-.594.387c-.172.167-.304.37-.387.594-.07.182-.155.456-.178.96-.025.545-.03.708-.03 2.088s.005 1.543.03 2.088c.023.504.107.778.178.96.083.225.215.427.387.594a1.6 1.6 0 0 0 .594.387c.182.07.456.155.96.178.545.025.708.03 2.088.03s1.543-.005 2.088-.03c.504-.023.778-.107.96-.178.45-.174.807-.53.98-.981.071-.182.156-.456.179-.96.024-.545.03-.708.03-2.088s-.005-1.543-.03-2.088c-.023-.504-.107-.778-.178-.96M9 11.654a2.654 2.654 0 1 1 0-5.308 2.654 2.654 0 0 1 0 5.308m2.759-4.793a.62.62 0 1 1 0-1.24.62.62 0 0 1 0 1.24",
    fill: "#fff",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 0a9.001 9.001 0 0 0 0 18A9.001 9.001 0 0 0 9 0m5.137 11.13c-.025.55-.113.926-.24 1.255a2.64 2.64 0 0 1-1.512 1.512c-.328.127-.704.215-1.254.24-.551.025-.727.031-2.13.031s-1.58-.006-2.132-.031c-.55-.025-.925-.113-1.254-.24A2.5 2.5 0 0 1 4.7 13.3a2.5 2.5 0 0 1-.596-.915c-.128-.328-.216-.704-.24-1.254-.026-.551-.032-.728-.032-2.131 0-1.404.006-1.58.031-2.13s.113-.926.24-1.255c.13-.345.334-.657.597-.915.258-.263.57-.467.915-.597.329-.127.704-.215 1.254-.24.551-.025.728-.031 2.131-.031s1.58.006 2.13.031.926.113 1.255.24c.345.13.657.334.916.597.262.258.466.57.596.915.127.329.215.704.24 1.254.025.551.031.728.031 2.131s-.006 1.58-.031 2.13",
    fill: "#fff",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInstagram);
export default __webpack_public_path__ + "static/media/ic_instagram.823363802c126eea2865a92ea9f27b50.svg";
export { ForwardRef as ReactComponent };